import moment from 'mj-moment'
import { TIME_FINISH_COMMUNITY_TOPIC } from '@/utils/constants/commons'

export default defineNuxtRouteMiddleware(async (to, from) => {
  if (!to.name || !to.name.includes('community') || moment().isBefore(TIME_FINISH_COMMUNITY_TOPIC)) return
  showError({ statusCode: 404 })
})
